import React from 'react'
import Svg from './Svg'
export const SvgComplaints = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M17.372 14.249c-1.495 1.544-1.495 3.091-2.991 3.091s-2.993-1.547-4.489-3.091c-1.496-1.547-2.991-3.091-2.991-4.638 0-1.544 1.495-1.544 2.991-3.092C11.388 4.975 6.901.337 5.405.337 3.908.337.917 4.975.917 4.975c0 3.092 3.074 9.356 5.984 12.365 2.91 3.006 8.976 6.183 11.967 6.183 0 0 4.488-3.092 4.488-4.639 0-1.544-4.488-6.182-5.984-4.635z" />
  </Svg>
))
SvgComplaints.isIcon = true
export default SvgComplaints
